import { action } from '@ember/object';

import type { Args as GoalsItemBaseArgs } from 'webapp/components/goals/item-base';
import GoalsItemBaseComponent from 'webapp/components/goals/item-base';
import { TopStrategyItemId as TreeTopStrategyItemId } from 'webapp/components/goals/tree/index';

export interface Args extends GoalsItemBaseArgs {
	depth: number;
	parentId: number;
	expandedIds: number[];
	toggleExpanded: (id: number) => void;
}

export default abstract class GoalsHierarchyTableRowComponent<
	T extends Args,
> extends GoalsItemBaseComponent<T> {
	get classNames() {
		const classNames = [
			'table-row',
			'goal-item',
			'goal-row--hierarchy',
			this.goalData.currentProgressClass,
			'hideSort',
			`depth-${this.args.depth}`,
		];

		if (!this.isVisible) {
			classNames.push('hidden');
		}

		if (this.isSelected) {
			classNames.push('selected');
		}

		return classNames;
	}

	get isVisible() {
		const parentId = this.args.parentId;
		if (!parentId || parentId === TreeTopStrategyItemId) {
			return true;
		}
		return this.args.expandedIds.includes(parentId);
	}

	get isExpanded() {
		return this.args.expandedIds.includes(this.args.model.numericId!);
	}

	get iconForArrow() {
		const isAligned = !this.args.model.parentGoal?.isSubgoalsProgressGoal;
		return isAligned ? 'ConnectorDashed' : 'Connector';
	}

	get subgoalsCount() {
		return this.args.model.children.length;
	}

	get subgoalsText() {
		const count = this.subgoalsCount;
		return `${count} Sub-goal${count === 1 ? '' : 's'}`;
	}

	override get goalData() {
		// will be always available bcos goal is saved
		return this.model.hierarchyDataModelWithFallback!;
	}

	@action
	toggleExpanded() {
		this.args.toggleExpanded(this.args.model.numericId!);
	}
}
